import { CommonResponse, TargetMenu } from 'models';
import axiosClient from 'utils/axiosClient';
import { Overlay } from './models/overlay';

const overlayService = {
  getAll(): Promise<CommonResponse<Overlay[]>> {
    const url = '/overlays';
    return axiosClient.get(url);
  },
  getDetail(id: number): Promise<CommonResponse<Overlay>> {
    const url = '/overlays';
    return axiosClient.get(`${url}/${id}`);
  },
  create(params: Overlay): Promise<CommonResponse<Overlay>> {
    const url = '/overlays';
    return axiosClient.post(url, params);
  },
  update(id: number, params: Overlay): Promise<CommonResponse<Overlay>> {
    const url = '/overlays';
    return axiosClient.patch(`${url}/${id}`, params);
  },
  delete(ids: number[]): Promise<CommonResponse<Overlay>> {
    const url = '/overlays';
    const idsParam = `?ids=${ids}`;
    return axiosClient.delete(`${url}${idsParam}`);
  },
  restore(id: number): Promise<CommonResponse<Overlay>> {
    const url = '/overlays/restore';
    return axiosClient.patch(`${url}/${id}`);
  },
  updateMenus(id: number, menuIds: number[]): Promise<CommonResponse<Overlay>> {
    const url = '/overlays-menus';
    const body = { id: id, menu_ids: menuIds };
    return axiosClient.post(`${url}`, body);
  },
  listMenus(id: number): Promise<CommonResponse<TargetMenu[]>> {
    const url = '/overlays-menus';
    return axiosClient.get(`${url}/${id}`);
  },
  addMenus(id: number, menuIds: number[]): Promise<CommonResponse<Overlay>> {
    const url = '/overlays-menus';
    const body = { id: id, menu_ids: menuIds };
    return axiosClient.post(`${url}`, body);
  },
  deleteMenus(id: number, menuIds: number[]): Promise<CommonResponse<Overlay>> {
    const url = '/overlays-menus';
    const body = { id: id, menu_ids: menuIds };
    return axiosClient.delete(url, { data: body });
  },
};

export default overlayService;
